var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulletedListActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5C1.2 5.5 0.5 6.2 0.5 7C0.5 7.8 1.2 8.5 2 8.5C2.8 8.5 3.5 7.8 3.5 7C3.5 6.2 2.8 5.5 2 5.5ZM2 0.5C1.2 0.5 0.5 1.2 0.5 2C0.5 2.8 1.2 3.5 2 3.5C2.8 3.5 3.5 2.8 3.5 2C3.5 1.2 2.8 0.5 2 0.5ZM2 10.5C1.2 10.5 0.5 11.2 0.5 12C0.5 12.8 1.2 13.5 2 13.5C2.8 13.5 3.5 12.8 3.5 12C3.5 11.2 2.8 10.5 2 10.5ZM5.5 1V3H19.5V1H5.5ZM5.5 13H19.5V11H5.5V13ZM5.5 8H19.5V6H5.5V8Z",
    fill: "#5A5AF2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletedListActive);
export default __webpack_public_path__ + "static/media/bulletedList-active.28bb361081b0b4c6340d1d0b46728bb9.svg";
export { ForwardRef as ReactComponent };